import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import RoomSelect from "../../components/RoomSelect";
import { RoomType } from "../../controller/MasterController";
import "../../styles/CustomModal.css";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../controller/ToastController";
import { langState, langText } from "../../recoil/lang";
import { useRecoilState, useRecoilValue } from "recoil";

const RoomNumberModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  storeId: number;
  setKioskAreaNumber: any;
  setKioskRoomNumber: any;
  setAreaName: any;
  setRoomName: any;
  doPayment: any;
  setPaymentReady:any;
}) => {
  const showToast = useToast();
  const [lang, setLang] = useRecoilState<number>(langState);
  const [selectedArea, setSelectedArea] = useState<number>(-1);
  const [selectedRoom, setSelectedRoom] = useState<number>(-1);
  const onCloseModal = () => {
    oProps.setVisible(false);
  };
  const goPayment = () => {
    if (selectedArea === -1 || selectedRoom === -1) {
      showToast(langText.select_room_toast[lang], "error");
    } else {
      oProps.setPaymentReady(true);
      oProps.doPayment();
    }
  };
  useEffect(() => {
    oProps.setKioskAreaNumber(selectedArea);
    oProps.setKioskRoomNumber(selectedRoom);
  }, [selectedArea, selectedRoom]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "selectAreaModalOverlay",
        modal: "selectAreaModal",
      }}
      closeOnOverlayClick={true}
      showCloseIcon={true}
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="닫기 아이콘"
        />
      }
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h2>{langText.select_room_number[lang]}</h2>
          </div>

          <div className="modal_content">
            <RoomSelect
              selectedArea={selectedArea}
              selectedRoom={selectedRoom}
              setSelectedArea={setSelectedArea}
              setSelectedRoom={setSelectedRoom}
              setAreaName={oProps.setAreaName}
              setRoomName={oProps.setRoomName}
            />
          </div>
          <div className="modal_footer">
            <button onClick={goPayment} className="submitButton">
              {langText.button_confirm[lang]}
            </button>
            <button className="submitButton cancel" onClick={onCloseModal}>
              {langText.orderStatus_button_cancel[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RoomNumberModal;

const Style = styled.div`
  .modal {
    width: 100%;
    height: 70vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  h2 {
    font-weight: 500;
    color: #ffffff;
  }

  .modal_header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 20px;
    gap: 20px;
    border-bottom: 1px solid #555555;
    h2 {
      padding-left: 32px;
    }
  }
  .modal_content {
    flex: 1;
    padding-top: 5%;
    overflow-y: auto;
  }

  .modal_footer {
    padding: 10%;
    .submitButton {
      width: 100%;
      padding: 14px 0;
      border: 1px solid #4dd2ae;
      background: #4dd2ae;
      border-radius: 5px;
      color: #ffffff;
      font-size: 24px;
      line-height: 30px;
      font-weight: 600;
    }
    .submitButton.cancel {
      margin-top: 14px;
      border: 1px solid #a7a7a7;
      background: #343434;
      color: #cecece;
    }
  }
`;
